
















import Vue from 'vue';

export default Vue.extend({
  name: 'StaySplash',
  props: {
    name: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    img: {
      type: String,
      default: '',
    },
  },
  methods: {
    onStarted() {
      this.$emit('get-started');
    },
    onCurate() {
      this.$emit('curate-trip');
    },
  },
});
